import { deleteCookie, getCookie } from 'cookies-next'
import { PENDING_SSO_LINK_COOKIE_NAME, parsePendingSsoLinkProvider } from '@/lib/auth/pendingSsoLink'
import type { SsoProviderKey } from '@/lib/auth/ssoProviders'

export function getPendingSsoLinkProvider(): SsoProviderKey | null {
    return parsePendingSsoLinkProvider(getCookie(PENDING_SSO_LINK_COOKIE_NAME))
}

export function clearPendingSsoLink(): void {
    deleteCookie(PENDING_SSO_LINK_COOKIE_NAME, {
        path: '/',
        domain: process.env.NEXT_PUBLIC_COOKIE_DOMAIN,
    })
}
